import React, { forwardRef } from "react";
import {
  Select,
  SelectOption,
  Checkbox,
  Input as SIInput,
  ButtonToggle,
  Switch,
} from "@showitinc/showit-wc";
import BaseColorPicker from "@showitinc/color-picker";
import {
  BASE_COLOR_PICKER,
  BUTTON_TOGGLE,
  CHECKBOX,
  COLOR_PICKER,
  INPUT,
  SELECT,
  SWITCH,
} from "../../constants/InputConstants.mjs";
import ColorPicker from "./ColorPicker";
import { MIXED } from "../../constants/DesignConstants.mjs";
import { ensureArray } from "../../utils/JSUtils";

export const COMPONENT_MAP = {
  [BASE_COLOR_PICKER]: BaseColorPicker,
  [BUTTON_TOGGLE]: ButtonToggle,
  [CHECKBOX]: Checkbox,
  [COLOR_PICKER]: ColorPicker,
  [INPUT]: SIInput,
  [SELECT]: Select,
  [SWITCH]: Switch,
};

const updateSelectChildren = (props, children) =>
  props?.value === MIXED
    ? [
        <SelectOption value={MIXED} key={MIXED}>
          Mixed
        </SelectOption>,
        ...ensureArray(children),
      ]
    : children;

const Input = forwardRef(({ inputType = INPUT, propName, children, mixed, ...rest }, ref) => {
  const Component = COMPONENT_MAP[inputType];
  const modifiedChildren = inputType === SELECT ? updateSelectChildren(rest, children) : children;

  return (
    <Component {...rest} ref={ref} mixed={rest.value === MIXED || rest.checked === MIXED || mixed}>
      {modifiedChildren}
    </Component>
  );
});

export default Input;
